var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "nav-item dropdown d-lg-flex align-items-center" },
    [
      _c(
        "a",
        {
          staticClass: "nav-link dropdown-toggle px-2 notification-toggle",
          attrs: {
            "aria-expanded": "false",
            "aria-haspopup": "true",
            "data-toggle": "dropdown",
            href: "#",
            role: "button"
          }
        },
        [
          _c("font-awesome-icon", { attrs: { icon: ["fas", "bell"] } }),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !!_vm.notifications.length,
                  expression: "!!notifications.length"
                }
              ],
              staticClass: "badge badge-danger count-badge"
            },
            [_vm._v(_vm._s(_vm.notifications.length))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "dropdown-menu dropdown-menu-right notification-dropdown position-absolute mt-2"
        },
        [
          _vm.notifications.length === 0
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v(
                  " " + _vm._s(_vm.T.notificationsNoNewNotifications) + " "
                )
              ])
            : _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("read", _vm.notifications, null)
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.T.notificationsMarkAllAsRead) + " ✔️ "
                  )
                ]
              ),
          _c(
            "transition-group",
            { attrs: { name: "list" } },
            _vm._l(_vm.notifications, function(notification) {
              return _c("omegaup-notification", {
                key: notification.notification_id,
                attrs: {
                  "data-notification-list": "",
                  notification: notification
                },
                on: { remove: _vm.readSingleNotification }
              })
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }